import { environment } from "../../website/website-environment";

export class BaseService {
    getBaseUrl(env) {
        return env == 'prod' ? environment.websiteApiBaseUrl : environment.websiteApiBaseUrlStaging
    }
}